import {Component} from "../interface/component";

export class ArticlesComponent implements Component {
    private $root: JQuery;
    private $load_more: JQuery;
    private $load_more_button: JQuery;
    private $container: JQuery;
    private $search_form:JQuery;
    private $sort_form:JQuery;
    private $search_results:JQuery;
    private $search_keyword:JQuery;
    private $search_submit:JQuery;

    private current_page:number;
    private max_pages:number;
    private num_posts:number;
    private has_more_pages:Boolean = true;

    private label_load_more: string;
    private label_no_more: string;

    constructor(elem: HTMLElement) {
        this.$root = $(elem);
        this.$container = this.$root.find('.js-articles-container');
        this.$load_more = this.$root.find('.js-load-more');
        this.$load_more_button = this.$load_more.find('.js-load-more-button');
        this.$search_form = this.$root.find('.js-listing-search-form');
        this.$sort_form = this.$root.find('.js-listing-sort-form');
        this.label_load_more = this.$load_more_button.text();
        this.label_no_more = this.$load_more.data('label-no-more');
        this.$search_results = this.$root.find('.js-search-results');
        this.$search_keyword = this.$root.find('.js-search-keyword');
        this.$search_submit = this.$root.find('.js-listing-search-form-submit');

        this.updateDataFromDataAttributes(this.$container);
    }

    public init = () => {
        this.$load_more.on({click: this.loadMore});
        this.$search_form.on({submit: this.refreshPosts});
        this.$sort_form.on({submit: this.refreshPosts});
        this.handleMaxPagesReached();
    }

    private loadMore = (ev:Event) => {
        ev.preventDefault();
        if (this.has_more_pages) {
            let data = this.$search_form.serializeArray().concat(this.$sort_form.serializeArray());
            let next_page = this.current_page + 1;
            data.push({name: "paged", value: next_page.toString()});
            this.$load_more.addClass('c-actions--loading-in-progress');
            $.get(this.$search_form.attr('action'), data, this.onLoadMoreResponse);
        }
    }

    private refreshPosts = (ev:Event) => {
        ev.preventDefault();
        let data = this.$search_form.serializeArray().concat(this.$sort_form.serializeArray());
        data.push({name: "paged", value: "1"});
        this.$search_submit.addClass('c-form-submit--submitting');
        $.get(this.$search_form.attr('action'), data, this.onUpdateSearchResponse);
    }

    private onLoadMoreResponse = (data:any) => {
        this.$load_more.removeClass('c-actions--loading-in-progress');
        let response = $(data).find('.js-articles-container');
        let new_posts = response.children();

        this.updateDataFromDataAttributes(response);
        new_posts.fadeOut(0, "linear");
        this.$container.append(new_posts);
        this.fadeInPosts(new_posts);
        this.handleMaxPagesReached();
        this.updateResultsMessage();
    }

    private onUpdateSearchResponse = (data:any) => {
        this.$search_submit.removeClass('c-form-submit--submitting');
        let response = $(data).find('.js-articles-container');
        let existing_posts = this.$container.children();
        let new_posts = response.children();

        this.updateDataFromDataAttributes(response);
        new_posts.fadeOut(0, "linear");
        existing_posts.remove();
        this.$container.append(new_posts);
        this.fadeInPosts(new_posts);
        this.handleMaxPagesReached();
        this.updateResultsMessage();
        this.updateSearchKeyword();
    }

    private updateSearchKeyword = () => {
        let keyword  = this.$root.find('[name=s]').val().toString();

        if (keyword.length){
            this.$search_keyword.parent().removeClass('hidden');
        }else{
            this.$search_keyword.parent().addClass('hidden');
        }
        this.$search_keyword.text(keyword);
    }

    private handleMaxPagesReached = () => {
        if (this.current_page == this.max_pages){
            this.$load_more.addClass('c-load-more--disabled');
            this.$load_more_button.attr('disabled', 'disabled')
                .text(this.label_no_more);
            this.has_more_pages = false;
        }else{
            this.$load_more.removeClass('c-load-more--disabled');
            this.$load_more_button.removeAttr('disabled')
                .text(this.label_load_more);
            this.has_more_pages = true;
        }
    }

    private fadeInPosts = ($posts: JQuery) => {
        let timeout = 0;
        let timeout_per_post = 200;
        $posts.each((index:number, element:HTMLElement) => {
            setTimeout(() => {
                $(element).fadeIn(timeout_per_post, "swing");
            }, timeout);
            timeout += timeout_per_post;
        });
    }

    private updateDataFromDataAttributes = ($element: JQuery) => {
        this.current_page = $element.data('current-page');
        this.max_pages = $element.data('max-pages');
        this.num_posts = $element.data('num-results');
    }

    private updateResultsMessage = () => {
        this.$search_results.text(this.num_posts);
    }
}